import React from "react";

interface HeadingProps {
  children: React.ReactNode;
  level: number;
}

export const Heading = (props: HeadingProps) => {
  switch (props.level) {
    case 1:
      return (
        <h1 className="my-4 text-2xl font-extrabold text-sky-500 dark:text-slate-400">
          {props.children}
        </h1>
      );
    case 2:
      return (
        <h2 className="text-1xl my-3 font-extrabold  dark:text-white">
          {props.children}
        </h2>
      );
    case 3:
      return (
        <h3 className="text-2x my-2 font-extrabold  dark:text-white">
          {props.children}
        </h3>
      );
    default:
      return (
        <h4 className="text-1x my-2 font-extrabold  dark:text-white">
          {props.children}
        </h4>
      );
  }
};
